'use client';

import React, { useEffect, useMemo, useState } from 'react';
import OfferCard from '../OfferCard/OfferCard';
import OfferDetails from '../OfferCard/OfferDetails';
import { OfferCardData } from '../OfferCard/types';

/**
 * Transform a plain JS Date object into the format
 * YYYYMMDD so that we are able to do manipulation on
 * @param d Date
 * @returns
 */
function transformDateToYMD(d: Date) {
  const m = `${d.getMonth() + 1}`.padStart(2, '0');
  const day = `${d.getDate()}`.padStart(2, '0');
  return `${d.getFullYear()}${m}${day}`;
}

type OffersDynamicClientData = {
  offers: OfferCardData[];
};

const OffersDynamicClient: React.FC<{ data: OffersDynamicClientData }> = ({ data }) => {
  const { offers } = data;
  const [dateFilter, setDateFilter] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState<OfferCardData | null>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const filteredOffers = useMemo(() => {
    // Don't filter by date until we're on the client
    if (!dateFilter) return offers;

    return offers.filter((o) => {
      if (o.expirationDate) {
        const expiration = transformDateToYMD(new Date(o.expirationDate));
        const today = transformDateToYMD(new Date());

        return expiration >= today;
      }

      return true;
    });
  }, [offers, dateFilter]);

  useEffect(() => {
    setDateFilter(true);
  }, []);
  return (
    <section className='mx-auto w-full max-w-[1248px] px-6 xl:px-0 flex flex-col items-center @container'>
      <div className='w-full grid grid-cols-1 md:grid-cols-2 gap-8 mb-[64px] @max-md:grid-cols-1'>
        {filteredOffers.map((o, idx) => {
          return (
            <div
              key={`offer-${o.title}-${idx}`}
              className='flex flex-col'
            >
              <OfferCard
                data={o as any}
                onOpen={(offer) => {
                  setSelectedOffer(offer);
                  setIsDrawerOpen(true);
                }}
              />
            </div>
          );
        })}
      </div>

      <OfferDetails
        data={selectedOffer}
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
    </section>
  );
};

export default OffersDynamicClient;
